module.exports = __webpack_public_path__ + "static/img/sdab_zyms_one.4f5557b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdab_zyms_one.png
// module id = Nw8t
// module chunks = 21